import { sel, selAll } from '../utils'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default function Testimonials() {
  const testLo$ = sel('.test__lo')
  if (!testLo$) return

  // const testSec$ = sel('.test-sec')
  const testItem$a = selAll('.test__item')
  let testItemRight$a = []
  const testLoOffset = testLo$.offsetLeft
  testItem$a.forEach((el, i) => {
    const elOffset = el.offsetLeft
    // console.log(testLoOffset - elOffset)

    if (testLoOffset - elOffset < 0) {
      testItemRight$a.push(el)
    }
  })
  // gsap.set(testItemRight$a, { y: 100 })

  ScrollTrigger.create({
    trigger: testLo$,
    start: 'top bottom',
    endTrigger: testLo$,
    end: 'bottom top',
    scrub: true,
    animation: gsap.fromTo(testItemRight$a, { y: 100 }, { y: -100, ease: 'none' }),
  })
}
